"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GET_ALL_CHATS_FAILED = exports.GET_ALL_CHATS_SUCCEEDED = exports.GET_ALL_CHATS_REQUESTED = void 0;
const service_1 = __importDefault(require("../../services/chats/service"));
const chatFunctions = __importStar(require("../../domain/model/chats"));
const constants_1 = require("../../constants");
const viewMode_1 = require("../../domain/model/viewMode");
const historyFunctions_1 = require("../../domain/historyFunctions");
const Alert_1 = require("../../components/modals/Alert");
exports.GET_ALL_CHATS_REQUESTED = "GET_ALL_CHATS_REQUESTED";
exports.GET_ALL_CHATS_SUCCEEDED = "GET_ALL_CHATS_SUCCEEDED";
exports.GET_ALL_CHATS_FAILED = "GET_ALL_CHATS_FAILED";
function default_1() {
    return (dispatch, getState) => __awaiter(this, void 0, void 0, function* () {
        const requestEvent = {
            type: exports.GET_ALL_CHATS_REQUESTED
        };
        dispatch(requestEvent);
        const response = yield service_1.default.getUpdates({
            updatedSince: null,
            messageCountForTopChat: constants_1.PAGE_SIZE
        });
        let outcomeEvent;
        if (response.kind === "success") {
            const viewMode = getState().appState.viewMode;
            const chats = response.chats;
            let chatIndex = (chats.length > 0 && viewMode === viewMode_1.ViewMode.Desktop) ? 0 : null;
            const selectedChatId = historyFunctions_1.extractChatIdFromLocation();
            if (selectedChatId != null) {
                const [_, index] = chatFunctions.tryGetChat(chats, selectedChatId);
                if (index >= 0) {
                    chatIndex = index;
                }
            }
            outcomeEvent = {
                type: exports.GET_ALL_CHATS_SUCCEEDED,
                payload: {
                    chats: response.chats,
                    blockedUsers: response.blockedUsers,
                    latestUpdateTimestamp: response.latestUpdateTimestamp,
                    selectedChatIndex: chatIndex
                }
            };
            if (chats.length == 0) {
                Alert_1.alertDialog(constants_1.ABOUT_US);
            }
        }
        else {
            outcomeEvent = {
                type: exports.GET_ALL_CHATS_FAILED,
                httpError: response.kind === "httpError" ? response : undefined
            };
        }
        dispatch(outcomeEvent);
    });
}
exports.default = default_1;
